import React from "react"
import Select from "react-select"

import { filterSelectStyles } from "../../utils"
import { SelectOption } from "../../models/common"
import useDictionary from "../../hooks/useDictionary"

interface ListingSelectProps {
  label?: string
  param: string | null | undefined
  options: SelectOption[]
  handleChange: (option: SelectOption | null) => void
  pageContext: any
}

const defaultProps = {}

export const ListingSelect: React.FC<ListingSelectProps> = props => {
  if (!props.param && props.options.length <= 2) return null

  const paramOption = props.options.filter(x => x.value === props.param)[0]

  return (
    <div className="cell auto filter">
      {props.label && <label className="filter__label">{props.label}</label>}
      <Select
        placeholder={
          useDictionary("Filter by", props.pageContext.locale) + "..."
        }
        value={props.param ? paramOption : undefined}
        options={props.options}
        onChange={props.handleChange}
        styles={filterSelectStyles}
        className="filter__select"
      />
    </div>
  )
}

ListingSelect.defaultProps = defaultProps

export default ListingSelect
